// extracted by mini-css-extract-plugin
export default {"ShareBody":"shareModal_ShareBody__Olb4T","ShareBox":"shareModal_ShareBox__ov2GP","ShareTips":"shareModal_ShareTips__q56lE"};